<template>
  <div
    class="auth-wrapper auth-v2"
    :dir="$functions.currentLangDirection()"
  >
    <b-row
      class="auth-inner m-0"
      style="direction: ltr;"
    >
      <!-- Brand logo-->
      <b-link class="brand-logo">
        <h2 class="brand-text text-primary ml-1" />
        <span class="brand-logo">
          <!-- <b-img
              :src="appLogoImage"
            alt="logo"
          />-->
        </span>
      </b-link>
      <!-- /Brand logo-->

      <!-- Left Text-->
      <b-col
        lg="12"
        class="d-none d-md-flex d-lg-flex align-items-center p-0"
      >
        <div class="w-100 d-lg-flex align-items-center justify-content-center px-0">
          <b-img
            fluid
            :src="imgUrl"
            alt="Login V2"
          />
        </div>
      </b-col>
      <!-- /Left Text-->

      <!-- Login-->
      <b-col
        lg="4"
        class="d-flex align-items-center auth-bg px-2 p-4 p-lg-1 form-auth"
        :style="{ backgroundImage: `url(${backgroundUrl})` }"
        :class="{ mainbox: !isMobile}"
        style="background-size: cover;background-position: center;direction: rtl;"
      >
        <b-col
          sm="12"
          md="12"
          lg="12"
          class="box2 px-xl-2 mx-auto"
          style="margin-top: -140px;"
          :dir="$functions.currentLangDirection()"
        >
          <b-card-title
            title-tag="h2"
            class="font-weight-bold mb-4"
          >
            {{ $t('Welcome') }}
          </b-card-title>
          <b-card-text class="mb-2">
            {{ $t('Sign in Description') }}
          </b-card-text>

          <!-- form -->
          <validation-observer ref="loginValidation">
            <div
              class="auth-login-form mt-2"
            >
              <b-form-group
                :label="$t('Mobile')"
                label-for="login-mobile"
              >
                <vue-tel-input
                  v-model="user.mobile"
                  :only-countries="['ir', 'af', 'ae', 'iq', 'tj']"
                  default-country="IR"
                  @input="phone"
                  :placeholder="$t('Enter Mobile Number')"
                />
                <small class="text-danger">{{ errors }}</small>
              </b-form-group>

              <!-- submit buttons -->
              <b-button
                type="submit"
                variant="success"
                block
                :disabled="loading"
                @click="formValidation"
              ><b-spinner
                 v-if="loading"
                 variant="outline-primary"
                 small
               />
                {{ $t('Sign in') }}
              </b-button>

              <!-- divider -->
              <div class="divider-or">
                <span>یا</span>
              </div>

              <!-- ورود با رمز عبور -->
              <b-button
                variant="outline-light"
                block
                :to="{name:'login-password'}"
              >
                ورود با رمز عبور
              </b-button>
            </div>

            <p
              class="text-center mt-2"
              style="display:none;"
            >
              <span>{{ $t('Not a member') }}</span>
              <b-link :to="{name:'register'}">
                <span style="font-weight: bolder;  underlinecolor: #c11919 !important;font-size: 1.2rem;">&nbsp;{{ $t('Register') }}</span>
              </b-link>
            </p>
          </validation-observer>
          <div
            class="mt-1 mt-4"
            style="text-align: center;"
          >
            <b-link

              class="mb-4"
              style="color: white; text-decoration: underline"
              @click="loginDemo"
            >
              {{ $t('Demo') }}
            </b-link>
            <br>

            <b-link
              style="color: white; text-decoration: underline;display: none"
              @click="changeAppLanguage('fa')"
            >
              {{ $t('Persian') }}
            </b-link>
            <b-link
              style="color: white; text-decoration: underline;display: none"
              @click="changeAppLanguage('en')"
            >
              {{ $t('English') }}
            </b-link>
          </div>

          <div class="row" style="bottom: -50px;position: inherit;">
            <div class="col-12">
              <div style="display: flex;margin: 0px auto; width: fit-content;">
                <span style="padding: 5px;">{{ $t('Select language') }} :
                  </span>
              <div style="width: 62px;" >
              <SwitchLang
                :init-lang="initLang"
                :options="optionsLang"
                :label="optionsLang.flag"
                @changed="changeAppLanguage"
              />
            </div>
            </div>
            </div>
          </div>
        </b-col>
      </b-col>
    <!-- /Login-->
    </b-row>
  </div>
</template>

<script>
/* eslint-disable global-require */
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import VuexyLogo from '@core/layouts/components/Logo.vue'
import { $themeConfig } from '@themeConfig'
import {
  BRow, BCol, BLink, BFormGroup, BFormInput, BInputGroupAppend, BInputGroup, BFormCheckbox, BCardText, BCardTitle, BImg, BForm, BButton, BSpinner, BFormSelect, BDropdown, BDropdownItem, BDropdownDivider,
} from 'bootstrap-vue'
import { required, email } from '@validations'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import Vue from 'vue'

import { VueTelInput } from 'vue-tel-input'

import store from '@/store/index'
import User from '@/models/user'
import { functions } from '@/functions'
// eslint-disable-next-line import/no-extraneous-dependencies
import SwitchLang from 'vue-switch-lang'
// eslint-disable-next-line import/no-extraneous-dependencies
import 'vue-switch-lang/dist/vue-switch-lang.css'

Vue.prototype.$functions = functions

export default {
  components: {
    SwitchLang,
    BDropdownDivider,
    BDropdownItem,
    BDropdown,
    BFormSelect,
    BRow,
    BCol,
    BLink,
    BFormGroup,
    BFormInput,
    BInputGroupAppend,
    BInputGroup,
    BFormCheckbox,
    BCardText,
    BCardTitle,
    BImg,
    BForm,
    BButton,
    VuexyLogo,
    BSpinner,
    ValidationProvider,
    ValidationObserver,
    VueTelInput,

  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      initLang: {
        title: 'fa',
        flag: 'ir',
      },

      user: new User('', '', '', '', ''),
      status: '',
      password: '',
      sideImg: require('@/assets/images/pages/login-v2.jpg'),
      backgroundImg: require('@/assets/images/pages/lg.jpg'),
      // validation rulesimport store from '@/store/index'
      required,
      email,
      loading: false,
      isMobile: Vue.prototype.$functions.isMobile(),
      errors: '',
      langCode: 'fa',
      optionsLang: [{ title: 'en', flag: 'gb' }, { title: 'fa', flag: 'ir' }, { title: 'ar', flag: 'sa' }],

    }
  },
  setup() {
    // App Name
    const { appName, appLogoImage } = $themeConfig.app
    return {
      appName,
      appLogoImage,
    }
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
    imgUrl() {
      return this.sideImg
    },
    backgroundUrl() {
      return this.backgroundImg
    },
  },
  beforeMount() {
    this.optionsLang.forEach(item => {
      if (item.title === localStorage.getItem('locale')) {
        this.initLang = {
          title: item.title,
          flag: item.flag,
        }
      }
    })
  },
  mounted() {

    const { isRTL } = $themeConfig.layout
    const formGroup = document.getElementsByClassName('form-auth')
    formGroup[0].style.direction = isRTL ? 'rtl' : 'ltr'
    if (Vue.prototype.$productionPlatform === 'android' || Vue.prototype.$productionPlatform === 'ios') {
      window.onpopstate = async () => {
        window.location.href = 'http://127.0.0.1:3232/QXNative/?action=terminate'
      }
    }
  },
  methods: {
    phone(number, phoneObject) {
      // console.log(phoneObject)
      if (phoneObject.isValid) {
        this.user.mobile = `0${phoneObject.number.significant}`
        this.errors = ''
      } else {
        // console.log(number, phoneObject)
        // eslint-disable-next-line no-lonely-if
        if (phoneObject.number.significant === 10) {
          this.errors = 'شماره وارد اشتباه می  باشد.'
        }
      }
    },
    changeAppLanguage(val) {
      localStorage.setItem('locale', val.title)
      window.location = '/'
    },
    loginDemo() {
      this.$store.dispatch('auth/loginVerify', {
        code: '99999',
        mobile: '09120000000',
      }).then(
        () => {
          this.$router.push('/')
          //   this.sending = false
        }, error => {
          this.sending = false
          this.loading = false
          // console.log(error)
          this.message = (error.response && error.response.data)
                || error.message
                || error.toString()
          this.$toast({
            component: ToastificationContent,
            props: {
              title: this.$t('Error'),
              text: this.message,
              icon: 'XIcon',
              variant: 'danger',
              dir: Vue.prototype.$functions.currentLangDirection(),
            },
          })
        },
      )
    },
    formValidation() {
      if (this.user.mobile.length === 11) {
        this.loading = true
        this.$store.dispatch('auth/login', this.user).then(
          res => {
            // console.log(res.result)

            this.loading = false

            if (res.result.status === 'register') {
              Vue.prototype.$mobileR = this.user.mobile
              this.$router.push('/register-verify')

              // eslint-disable-next-line no-empty
            } else if (res.result.status === 'login') {
              Vue.prototype.$mobile = this.user.mobile
              this.$router.push('/login-verify')
            }
          }, error => {
            this.loading = false
            this.message = (error.response && error.response.data)
                      || error.message
                      || error.toString()
            this.$toast({
              component: ToastificationContent,
              props: {
                title: this.$t('Error'),
                text: this.$t(this.message),
                icon: 'XIcon',
                variant: 'danger',
                dir: Vue.prototype.$functions.currentLangDirection(),
              },
            })
          },
        )
      } else {
        this.errors = 'شماره وارد اشتباه می  باشد.'
      }
    },
  },

}
</script>

<style lang="scss">
[dir=ltr], [dir=ltr] .ltr * {
  direction: ltr !important;
  text-align: left;
}

@import '../../@core/scss/vue/pages/page-auth.scss';
.brand-logo img{
  width: 70px;
}
.auth-wrapper .auth-bg{
  background-color: #232633;
  color: #fff;
}
.auth-wrapper label,.auth-wrapper span,.auth-wrapper h2,.auth-wrapper .brand-text{
  color: #fff !important;
}
[dir=rtl] .vue-tel-input{
  direction: ltr;
}
.vti__dropdown-item{
  color: #000;
}
.vti__dropdown-item strong{
  font-weight: 400;
}
.vue-tel-input{
  background: #fff;
  padding: 3px;
}
.auth-wrapper label, .auth-wrapper span, .auth-wrapper h2, .auth-wrapper .brand-text{
  color: #eee !important;
}

.mainbox{
  background: #344935d6   !important;
  position: absolute;top: 10%;margin-left: auto;margin-right: auto;left: 0;right: 0;width: 400px;height: 500px;border-radius: 2%;
}
.mainbox .box2{
  margin-top: -40px !important;
}
.multiselect__option--selected {
  background-color: red;
}

.multiselect__option--highlight {
  background-color: #c6c6c7;
  background: #c6c6c7;
}
[dir] .multiselect__single{
  background: #fff0 !important;
  padding-right: 0px !important;
  margin-right: -10px !important;
}
[dir] .multiselect__tags{
  height: 32px!important;
  background: #fff0 !important;
}
[dir] .multiselect__select{
  width: 26px;
  border: 0;
  background: #fff0 !important;

  top: -2px;
}
[dir] .multiselect__option{
  padding: 1px;
}
[dir=ltr] .multiselect__single{
  left: 10px;
  display: block;
}
[dir] .normal-flag{
  transform: scale(.45) !important;
  -webkit-transform: scale(.45) !important;
}
.normal-flag[data-v-31fb7232]{
  margin-top: -5px;
  margin-right: -10px;
}
.divider-or {
  display: flex; align-items: center; margin: 15px 0;
}
.divider-or::before, .divider-or::after {
  content: ''; flex: 1; border-top: 1px solid #666;
}
.divider-or span {
  padding: 0 12px; font-size: 12px; color: #aaa;
}
</style>
